module.exports = __webpack_public_path__ + "img/logo.5ca614ff.png";